// extracted by mini-css-extract-plugin
module.exports = {"content":"Review_content__ty_CB","author":"Review_author__d_i_W"};